@if (showCountdownBanner) {
  <div class="voice-chat-banner">
    <p class="body">
      There {{ countdownSecondsRemaining === 1 ? 'is' : 'are' }} only
      <strong> {{ formattedCountdownSecondsRemaining }} </strong>
      {{ countdownSecondsRemaining === 1 ? 'second' : 'seconds' }} till the end of your voice session
    </p>
    <button class="button-wrapper" tabindex="0">
      <i class="fa-regular fa-xmark close-icon" (click)="closeCountdownBanner()"></i>
    </button>
  </div>
}

<div class="voice-chat-container" [class.hidden]="!isNovaSonicSelected">
  <span class="voice-title-section desktop-only">
    <i class="fa-light fa-waveform-lines"></i>
    <p class="body"><strong> Smart-fix</strong> Voice</p>
  </span>

  <div class="voice-transcript-container">
    @if (V2VisLoading()) {
      <section class="v2v-loading" aria-label="Loading voice chat">
        <app-loading-spinner [size]="48" [strokeWidth]="4" variant="blue"> </app-loading-spinner>
        <h4>{{ showDelayedLoadingCopy() ? 'Getting things ready...' : 'Loading voice chat...' }}</h4>
        <p class="body">
          {{
            showDelayedLoadingCopy()
              ? 'This may take a few moments'
              : 'Please make sure to allow microphone access in your browser'
          }}
        </p>
      </section>
    } @else {
      @if (showTopFade()) {
        <span class="chat-scroll-gradient"></span>
      }
      <div class="voice-transcript" #scrollContainer>
        <div class="chat-top-spacer" aria-hidden="true"></div>
        @for (group of voiceChatGroups(); track $index) {
          @if (group.role === 'agent') {
            <div class="voice-agent-text">
              <p qmEncrypt>{{ group.text }}</p>
            </div>
          }
          @if (group.role === 'user') {
            <div class="voice-user-bubble">
              <p class="body" qmEncrypt>{{ group.text }}</p>
            </div>
          }
        }
      </div>
    }

    <div class="voice-capsule-container desktop-only">
      <app-voice-capsule [baseHeight]="0.12"></app-voice-capsule>
    </div>
  </div>

  <div class="voice-action-buttons desktop-only">
    <div class="voice-controls-row">
      <app-button
        class="voice-mute-button"
        dataLabel="mute-button"
        [class.muted]="novaSonicService.micMuted()"
        [buttonOptions]="{ variant: 'secondary', disabled: !isNovaSonicActive }"
        (click)="toggleMicMute()"
        [attr.aria-label]="novaSonicService.micMuted() ? 'Unmute microphone' : 'Mute microphone'"
        [attr.aria-pressed]="novaSonicService.micMuted()"
      >
        <section class="button-action">
          <i class="fa-light" [ngClass]="novaSonicService.micMuted() ? 'fa-microphone-slash' : 'fa-microphone'"></i>
          {{ novaSonicService.micMuted() ? 'Unmute' : 'Mute' }}
        </section>
      </app-button>

      <app-button
        class="voice-end-chat-button"
        dataLabel="voice-close-btn"
        [buttonOptions]="{ variant: 'secondary' }"
        (click)="promptLeaveVoiceChat()"
        aria-label="Close voice chat"
      >
        <section class="button-action">
          <i class="fa-light fa-xmark"></i>
          End chat
        </section>
      </app-button>
    </div>
  </div>
</div>

<div class="voice-capsule-container mobile-only" [class.hidden]="!isNovaSonicSelected">
  <!-- Set base height higher (e.g. 0.45) so the surface starts well above the 80px bottom safe zone -->
  <app-voice-capsule [baseHeight]="0.45" [bottomSafeZone]="160"></app-voice-capsule>
  <div class="voice-action-buttons mobile-only">
    <div class="voice-controls-row">
      <app-button
        class="voice-mute-button"
        dataLabel="mute-button"
        [class.muted]="novaSonicService.micMuted()"
        [buttonOptions]="{ variant: 'secondary', disabled: !isNovaSonicActive }"
        (click)="toggleMicMute()"
        [attr.aria-label]="novaSonicService.micMuted() ? 'Unmute microphone' : 'Mute microphone'"
        [attr.aria-pressed]="novaSonicService.micMuted()"
      >
        <i class="fa-light" [ngClass]="novaSonicService.micMuted() ? 'fa-microphone-slash' : 'fa-microphone'"></i>
        {{ novaSonicService.micMuted() ? 'Unmute' : 'Mute' }}
      </app-button>

      <app-button
        class="voice-end-chat-button"
        dataLabel="voice-close-btn"
        [buttonOptions]="{ variant: 'secondary' }"
        (click)="promptLeaveVoiceChat()"
        aria-label="Close voice chat"
      >
        <i class="fa-light fa-xmark"></i>
        End chat
      </app-button>
    </div>
  </div>
</div>
